/**
 * Form → API DTO transformers. Inverse of sanitizeData (which goes
 * the other way: API DTO → Form).
 *
 * Pure functions extracted from src/app/services/users.service.js
 * (`getDataGeneral` / `getDataGeneralUpdate`) so they can live with
 * the rest of the user model and be tested in isolation.
 */

import type { IUserForm } from './user.types';

/**
 * Outbound payload shared by both create and update flows. Loose typing
 * because the backend tolerates several extra fields that the frontend
 * passes through unchanged.
 */
export interface IUserCreateDTO {
  country_guid: string | undefined;
  is_demo: 0 | 1;
  lastname: string;
  name: string;
  role: string;
  username: string;
  has_license_mint: 0 | 1;
}

export interface IUserUpdateDTO {
  avatar: string;
  change_password: 1 | undefined;
  country_guid: string | undefined;
  guid: string | undefined;
  is_demo: 0 | 1;
  lastname: string;
  name: string;
  password: string | undefined;
  role_guid: string;
  username: string;
}

/**
 * Build the create payload from form values.
 */
export function getDataGeneral(data: IUserForm): IUserCreateDTO {
  return {
    country_guid: data.country && typeof data.country === 'object' ? data.country.value : undefined,
    is_demo: data.is_demo ? 1 : 0,
    lastname: data.lastname,
    name: data.name,
    role: data.role,
    username: data.username,
    has_license_mint: data.has_license_mint ? 1 : 0,
  };
}

/**
 * Build the update payload from form values.
 */
export function getDataGeneralUpdate(data: IUserForm): IUserUpdateDTO {
  return {
    avatar: data.avatar,
    change_password: data.change_password ? 1 : undefined,
    country_guid: data.country && typeof data.country === 'object' ? data.country.value : undefined,
    guid: data.guid,
    is_demo: data.is_demo ? 1 : 0,
    lastname: data.lastname,
    name: data.name,
    password: data.password ? data.password : undefined,
    role_guid: data.role,
    username: data.username,
  };
}
